// extracted by mini-css-extract-plugin
export var chevronIcon = "_6y-2";
export var teamName = "_6y-1";
export var teamSwitcherButton = "_6y-0";